import { useState, useEffect } from 'react'
import { detectPlatform } from '@shared/lib'
import { Member } from './bank.types'

export interface SbpMembersResponse {
  version: string
  platform: 'ios' | 'android' | 'desktop'
  type: 'qr' | 'sub' | 'b2b' | 'c2g' | 'c2c' | 'b2c'
  members: Member[]
}

interface UseSbpMembersReturn {
  members: Member[] | null
  isMembersLoading: boolean
  membersError: string
}

export const useSbpMembers = (paymentUrl: string): UseSbpMembersReturn => {
  const [members, setMembers] = useState<Member[] | null>(null)
  const [isMembersLoading, setIsMembersLoading] = useState<boolean>(false)
  const [membersError, setMembersError] = useState<string>('')

  useEffect(() => {
    if (!paymentUrl) {
      setMembersError('Payment URL is required')

      return
    }

    const fetchData = async () => {
      setIsMembersLoading(true)
      setMembersError('')

      try {
        const platform = detectPlatform()

        const response = await fetch('https://widget.cbrpay.ru/v1/members', {
          method: 'GET',
          headers: {
            'X-CLIENT': 'LGS',
            'X-PLATFORM': platform,
            'X-PAYLOAD': paymentUrl,
          },
        })

        if (!response.ok) {
          const errorData = (await response.json()) as { message?: string }

          throw new Error(errorData.message || `HTTP error! status: ${response.status}`)
        }

        const result: SbpMembersResponse = await response.json()

        setMembers(result.members)
      } catch (err: unknown) {
        const errorMessage = err instanceof Error ? err.message : 'An unknown error occurred'

        setMembersError(errorMessage)
      } finally {
        setIsMembersLoading(false)
      }
    }

    fetchData()
  }, [paymentUrl])

  return { members, isMembersLoading, membersError }
}
